import React from "react";
import MainDashboardLayout from "../../../Layout/MainDashboardLayout";
import BRSRSidebar from "../../../Layout/BRSRSidebar";

const SectionC = () => {
  return (
    <MainDashboardLayout sidebar={<BRSRSidebar />}>
      SectionC
    </MainDashboardLayout>
  );
};

export default SectionC;
